import React from 'react';
import { usePriceList } from '../hooks/usePriceList';
import { getCurrentLocale } from '../services/api';

const PriceListSection: React.FC = () => {
  const { data, loading } = usePriceList();
  const locale = getCurrentLocale();

  // Default content when no Strapi data is available
  const defaultData = {
    title: locale === 'ar' ? 'باقة تناسب احتياجاتك' : 'Een pakket dat bij jouw wensen past',
    description:
      locale === 'ar'
        ? 'في HairMedics تحصل دائمًا على علاج مُصمم خصيصًا لك. نعمل بأسعار منفصلة وباقات للراغبين في العمل بشكل موجّه على استعادة نمو الشعر.'
        : 'Bij HairMedics krijg je altijd een behandeling op maat. We werken met losse tarieven én pakketten voor wie doelgericht aan de slag wil met haargroeirestherstel.',
    priceCards: [
      {
        id: 1,
        title: locale === 'ar' ? 'منطقة واحدة' : '1 zone',
        description:
          locale === 'ar' ? 'لمن يبدأ للتو ويريد تحسنًا ملحوظًا' : 'Voor wie net begint en zichtbare verbetering wil',
        features:
          locale === 'ar'
            ? ['استشارة + تحليل فروة الرأس', '4 جلسات لمنطقة واحدة', 'نصائح العناية اللاحقة', 'مجموعة منتجات']
            : ['Intake + hoofdhuidanalyse', '4 behandelingen voor 1 zone', 'Nazorgadvies', 'Productpakket'],
        price: '€495',
      },
      {
        id: 2,
        title: locale === 'ar' ? 'منطقتان' : '2 zones',
        description:
          locale === 'ar' ? 'لمناطق متعددة أو مشاكل شعر أعمق' : 'Voor meerdere zones of diepere haarproblemen',
        features:
          locale === 'ar'
            ? ['استشارة + تحليل فروة الرأس', '6 جلسات لمنطقتين', 'نصائح العناية اللاحقة', 'مجموعة منتجات']
            : ['Intake + hoofdhuidanalyse', '6 behandelingen voor 2 zones', 'Nazorgadvies', 'Productpakket'],
        price: '€795',
      },
      {
        id: 3,
        title: locale === 'ar' ? 'رعاية لاحقة' : 'Nazorg',
        description:
          locale === 'ar' ? 'للعملاء العائدين أو الصيانة بعد العلاجات السابقة' : 'Voor terugkerende cliënten of onderhoud na eerdere behandelingen',
        features:
          locale === 'ar' ? ['3 جلسات إنعاش', 'استشارة قصيرة للتوجيه'] : ['3 opfrissessies', 'Kort consult voor bijsturing'],
        price: '€795',
      },
    ],
  };

  if (loading) {
    return (
      <section className="price-list-section">
        <div className="loading-placeholder">
          <div className="loading-title">Loading...</div>
        </div>
      </section>
    );
  }

  // Merge Strapi data with sensible locale-specific defaults when fields are missing
  const title = data?.title || defaultData.title;
  const description = data?.description || defaultData.description;
  const cardsFromApi = Array.isArray(data?.priceCards) ? data!.priceCards : [];
  const sourceCards = cardsFromApi.length > 0 ? cardsFromApi : defaultData.priceCards;
  const mergedCards = sourceCards.map((card, index) => {
    const defaultCard = defaultData.priceCards[index] || {} as any;
    const features = Array.isArray(card.features) && card.features.length > 0
      ? card.features
      : (defaultCard.features || []);
    const price = card.price || defaultCard.price;
    const mergedTitle = card.title || defaultCard.title;
    const mergedDescription = card.description || defaultCard.description;
    return {
      id: card.id ?? defaultCard.id ?? index,
      title: mergedTitle,
      description: mergedDescription,
      features,
      price,
    };
  });

  return (
    <section className="price-list-section">
      <div className="price-list-container">
        <h2 className="section-title">{title}</h2>
        
        {description && (
          <p className="section-subtitle">{description}</p>
        )}

        <div className="price-cards-grid">
          {mergedCards.map((card) => (
            <div key={card.id} className="price-card">
              <h4 className="card-title-price">{card.title}</h4>
              {card.description && (
                <p className="package-description">{card.description}</p>
              )}
              <ul className="features-list">
                {(card.features || []).map((feature, index) => {
                  const text = typeof feature === 'string' ? feature : (feature as any)?.text;
                  if (!text) return null;
                  return (
                    <li key={index} className="feature-item">
                      {text}
                    </li>
                  );
                })}
              </ul>
              <div className="card-price">{card.price}</div>
            </div>
          ))}
        {data?.disclaimer && (
          <div className="price-disclaimer" dangerouslySetInnerHTML={{ __html: data.disclaimer }} />
        )}
        </div>
      </div>
    </section>
  );
};

export default PriceListSection;